import { render, staticRenderFns } from "./PortalOfficeIbowDetail.vue?vue&type=template&id=0a05f76e&scoped=true&"
import script from "./PortalOfficeIbowDetail.vue?vue&type=script&lang=ts&"
export * from "./PortalOfficeIbowDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PortalOfficeIbowDetail.vue?vue&type=style&index=0&id=0a05f76e&scoped=true&lang=css&"
import style1 from "./PortalOfficeIbowDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05f76e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VChip,VContainer,VSimpleTable,VSnackbar,VSpacer})
